export default "__VITE_ASSET__BFliwxOe__"